import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { IClearerListResponseData } from '../../models/clearer/clearerList.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import { clearerActions } from '../../redux/slices/clearerSlice';
import { useAppDisPatch } from '../../redux/store';
import useHttps from '../useHttps';

const useClearerList = () => {
  const dispatch = useAppDisPatch();
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const setClearerListError = (err: AxiosError<ErrorHttpResponse>) => {
    // console.log('Med os');
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while geting clearers list'
    );
  };

  const setClearerList = ({
    data,
  }: SuccessHttpResponse<IClearerListResponseData>) => {
    dispatch(clearerActions.setClearer({ clearersList: data.records }));
  };

  const getClearerList = () => {
    const url: HttpConfig = {
      url: 'authentication-service/v1/clearers?page=0&size=1000000000',
      method: 'get',
    };

    request(url, setClearerList, setLoading, setClearerListError);
  };

  return { getClearerList, loading };
};

export default useClearerList;
